import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconAlignCenter$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAlignCenter extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0e6f3191789e307589647df9c59906d32c77d27a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ad1bdccd26cf7ecf902ceb851b9dbfc440210847', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e505b71e00a4114cb26455e8b5baee87489d56b1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 5.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 3 6zm2 5.25a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5zm3.5 4.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-align-center", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-align-center"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-align-center":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAlignCenter$1);
            }
            break;
    } });
}

const CosmosIconAlignCenter = CosmosIconAlignCenter$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAlignCenter, defineCustomElement };
